//announcement
function setHeaderTop() {
  const announcement = document.querySelector('.announcement');
  const headerHolder = document.querySelector('.overlay_header .section-header-holder:not(.scrolled-past-header-holder)');

  if (announcement && headerHolder) {
    const announcementHeight = announcement.offsetHeight;
    headerHolder.style.top = announcementHeight + 'px';
  }
}

// ページ読み込み時とリサイズ時に実行
window.addEventListener('load', setHeaderTop);
window.addEventListener('resize', setHeaderTop);

const announcements = document.getElementsByClassName('cm-announcement');

// 要素が存在する場合のみ初期化
if (announcements.length > 0) {
  // 各cm-splide要素に対してSplideを初期化
  Array.from(announcements).forEach((slide) => {
    // スライドの数を確認
    const slideItems = slide.querySelectorAll('.splide__slide');
    const hasMultipleSlides = slideItems.length > 1;

    // data属性から値を取得
    const autoplay = slide.dataset.autoplay === 'true' && hasMultipleSlides;
    const interval = (parseInt(slide.dataset.interval) || 3) * 1000; // 秒をミリ秒に変換
    const speed = (parseInt(slide.dataset.speed) || 1) * 1000;

    let splide = new Splide(slide, {
      type: 'loop',
      perPage: 1,
      autoplay: autoplay,
      interval: interval,
      speed: speed,
      easing: 'ease',
      arrows: hasMultipleSlides,
      pagination: false,
      keyboard: false,
    });

    splide.mount();
  });
}

const announcement = document.querySelector('.announcement');
const announcementClose = document.querySelector('.cm-announcement__close');
// ページ読み込み時に sessionStorage を確認
if (sessionStorage.getItem('hideAnnouncement') === 'true') {
  // 前回閉じたなら非表示にする
  announcement?.classList.add('hidden');
}
if (announcementClose && announcement) {
  announcementClose.addEventListener('click', () => {
    announcement.classList.add('hidden');
    sessionStorage.setItem('hideAnnouncement', 'true');
  });
}

//splide
const slides = document.getElementsByClassName('cm-splide');

// 要素が存在する場合のみ初期化
if (slides.length > 0) {
  // 各cm-splide要素に対してSplideを初期化
  Array.from(slides).forEach((slide) => {
    // スライドの数を確認
    const slideItems = slide.querySelectorAll('.splide__slide');
    const hasMultipleSlides = slideItems.length > 1;

    // data属性から値を取得
    const autoplay = slide.dataset.autoplay === 'true' && hasMultipleSlides;
    const interval = (parseInt(slide.dataset.interval) || 3) * 1000; // 秒をミリ秒に変換
    const speed = (parseInt(slide.dataset.speed) || 3) * 1000;

    let splide = new Splide(slide, {
      type: 'fade',
      perPage: 1,
      autoplay: autoplay,
      interval: interval,
      speed: speed,
      easing: 'ease',
      arrows: true,
      pagination: hasMultipleSlides,
      rewind: true,
    });

    splide.mount();

    // スライドが1つの場合はplay_btnを非表示
    if (!hasMultipleSlides) {
      const playBtn = slide.querySelector('.play_btn');
      if (playBtn) {
        playBtn.style.display = 'none';
      }
    }
  });
}
